import Accordion from "components/Accordion";
import { HELP_FAQ_LIST } from "constants/help";
import { HAULPAY_HELP_BLOG } from "constants/link";
import styles from "./style.module.scss";

export default function HelpFAQ() {
  return (
    <div className={styles.helpFAQContainer}>
      <span className="text-primary">Common Help Questions</span>
      <div className="font-light">
        <span>For tips on using tools in the app we also recommend our </span>
        <a href={HAULPAY_HELP_BLOG} target="_blank" className="text-info" rel="noreferrer">
          blog
        </a>
      </div>

      <div className={styles.accordionContainer}>
        {HELP_FAQ_LIST.map((item) => (
          <Accordion key={item.id} data={item} />
        ))}
      </div>
    </div>
  );
}
